"use client";

import React, { useState } from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import { formatDateTimeToDDMMYYYYHHMMSS } from "@/helpers/date-helpers";
import { IServiceInterfaceLog } from "@/interfaces/service-interface.interface";
import { ServiceInterfaceMessages } from "@/messages/service-interface/service-interface.messages";

import { LOG_MESSAGE_MAX_LENGTH } from "../../constants";
import { MessageDetailModal } from "../MessageDetailModal";

type Props = {
  log: IServiceInterfaceLog;
  index: number;
  messages: ServiceInterfaceMessages;
  resolveLogTypeLabel: (code: string) => string;
};

export function ServiceInterfaceLogTableRow({
  log,
  index,
  messages,
  resolveLogTypeLabel,
}: Props) {
  const [modalOpen, setModalOpen] = useState(false);

  const truncatedMessage =
    log.logMessage.length > LOG_MESSAGE_MAX_LENGTH
      ? `${log.logMessage.substring(0, LOG_MESSAGE_MAX_LENGTH)}...`
      : log.logMessage;

  return (
    <>
      <TableRow index={index} onClick={() => setModalOpen(true)} sx={{ cursor: "pointer" }}>
        <TableCell>{log.id}</TableCell>
        <TableCell>{resolveLogTypeLabel(log.logType)}</TableCell>
        <TableCell>{truncatedMessage}</TableCell>
        <TableCell>{formatDateTimeToDDMMYYYYHHMMSS(log.rowDate)}</TableCell>
      </TableRow>

      <MessageDetailModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        message={log.logMessage}
        messages={messages}
      />
    </>
  );
}
